export const EXCLUDED_FUNCTIONS = ['VIEW', 'CSV'];
